<template>
    <div class="medical-records">
        <div class="row mb-4 food-section">
            <div class="col-12 grocery-list ">
                <div class="card border-0">
                    <div class="card-body bg-white border-radius-5 p-4">
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Vegetables</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/potatoes.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">270 g Potatoes (With Skin)</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="potatoes">
                                            <label class="mb-0" for="potatoes"></label>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/tomatoes.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">1/2 tomatoes (=195 g)</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="tomatoes">
                                            <label class="mb-0" for="tomatoes"></label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area mt-3">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Fresh Herbs</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/leaves.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">10 Leaves of basil, fresh</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="leaves">
                                            <label class="mb-0" for="leaves"></label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area mt-3">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Bakery & Bread</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/bread.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">160 g whole wheat bread</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="bread">
                                            <label class="mb-0" for="bread"></label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area mt-3">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Canned Goods</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/tomato-paste.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">26 g tomato paste</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="tomato-paste">
                                            <label class="mb-0" for="tomato-paste"></label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area mt-3">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Condiments & Sauces</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/barbecue.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">55 ml barbecue sauce</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="barbecue">
                                            <label class="mb-0" for="barbecue"></label>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 border-bottom  mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/soy-sauce.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">35 ml soy sauce, light</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="soy-sauce">
                                            <label class="mb-0" for="soy-sauce"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters  d-flex justify-content-center align-items-center Meals-area mt-3">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>OIl & Vinegar</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12  border-bottom mb-2 pb-2 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/oil.svg"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">8 ml canola oil</h3>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list ">
                                            <input type="checkbox" id="oil">
                                            <label class="mb-0" for="oil"></label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters mt-5 mb-3">
                            <div class="w-100 d-flex justify-content-center align-items-center  ">
                                <a href="#" class="btn btn-blue Finish-List">Finish Shopping List</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        name: 'grocery-list',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/recommended_diet/grocery-list.vue